var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`${
    _vm.classPath !== '' ? (_vm.hasOverlay ? 'page no-scroll' : 'page') : 'home'
  }`,attrs:{"id":"app"}},[_c('Header'),_c('router-view'),_c('Chatbot'),_c('Contact',{directives:[{name:"show",rawName:"v-show",value:(_vm.classPath !== 'contato'),expression:"classPath !== 'contato'"}]}),_c('Footer'),_c('Splash',{attrs:{"isLoading":_vm.isLoading}}),_c('Cookies'),_c('Overlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }